import AppRecord from './AppRecord.js'

class EntityExternalId extends AppRecord {

  // Used by the status filter, as an external id can be imported before it is related to an entity
  get matchStatus(){
    return this.entity_id ? 'matched' : 'unmatched'
  }

  // Used by the skip filter, as skipped external ids are left out of the assignment from guesses
  get skipStatus(){
    return this.skipped ? 'skipped' : 'not_skipped'
  }
}
export default EntityExternalId
